import React, { useEffect, useState } from "react";
import icons from "../../assets/images/sprite-other-icons.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAffiliateEarnsData, gamesSelectedList, generateAffiliate, getAffiliateDetails, setUserNameErrMsg, setAffiliateDetailsData } from "../home/cl_LoyalltyCoins";
import { endpoints } from "../../api/ApiEndPoints";
import { getFromLocalStorage } from "../../services/helper/cl_Helper";
import PaginationComponent from "../common/PaginationComponent";

const ViewAllEarns = () => {
  const navigate = useNavigate();
  let PageSize = 10;
  const { IsVipSearchBoxOpen, userDetails } = useSelector(
    state => state?.signIn
  )

  const {
    affiliateRes,
    selectedGamesList,
    updatedGamesList,
    successMsg,
    vipreportData,
    selectedUserName,
    userNameErrMsg,
    affiliatesData,
    affiliateDetailsData,
    allEarnLoader
  } = useSelector((state) => state.coinsHistory);

  const dispatch = useDispatch();
  const affiliateCode = getFromLocalStorage("ac");
  const [copiedText, setCopiedText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [userName, setUserName] = useState("");
  const [dateRange, setDateRange] = useState("last30");
  let currentDate = new Date();
  const [endDate, setEndDate] = useState(() => {
    const initialDate = new Date();
    return initialDate.toISOString();
  });
  const [startDate, setStartDate] = useState(() => {
    const initialDate = new Date();
    initialDate.setDate(initialDate.getDate() - 30);
    return initialDate.toISOString();
  });
  currentDate.setDate(currentDate.getDate() - 7);
  const finalDate = currentDate.toISOString().split('T')[0];
  const handleShare = async () => {
    const baseUrl = process.env.REACT_APP_FASFASREFERURL;
    const shareData = {
      title: "FasFas - BOSS",
      text: "FasFas - BOSS",
      url: `${baseUrl}/signup/?afid=${affiliateCode}`,
    };
    await navigator.share(shareData);
  };
  const shareUrl = () => {
    navigator.clipboard.writeText(
      `${process.env.REACT_APP_FASFASREFERURL}/signup/?afid=${affiliateCode}`
    );
    setCopiedText("Copied");
    setInterval(() => {
      setCopiedText("");
    }, 2000);
  };
  useEffect(() => {
    if (selectedUserName) {
      setUserName(selectedUserName);
    }
  }, [selectedUserName]);

  const handleNameInput = (e) => {
    setUserName(e.target.value);
    dispatch(setUserNameErrMsg(""));
  };
  const handleDataRange = (e) => {
    setCurrentPage(1);
    const value = e.target.value;
    setDateRange(value);
    // dispatch(getAffiliateDetails(startDate, endDate, affiliateCode))
    if (value === "custom") {
      setStartDate("");
      setEndDate("");
      dispatch(setAffiliateDetailsData(""))
    }
  };

  useEffect(() => {
    const currentDate = new Date();

    if (dateRange === "last7") {
      const end = currentDate.toISOString();
      currentDate.setDate(currentDate.getDate() - 7);
      const start = currentDate.toISOString();
      setEndDate(end);
      setStartDate(start);
    } else if (dateRange === "last30") {
      const end = currentDate.toISOString();
      currentDate.setDate(currentDate.getDate() - 30);
      const start = currentDate.toISOString();

      setEndDate(end);
      setStartDate(start);
    }
  }, [dateRange]);
  useEffect(() => {
    if (startDate && endDate && affiliateCode) {
      dispatch(getAffiliateDetails(startDate, endDate, affiliateCode, currentPage - 1, PageSize));
    }
  }, [startDate, endDate, affiliateCode, currentPage, dispatch]);

  const linkmode = () => {
    window.open(getReferralUrl(), "_blank");
  };

  const getReferralUrl = () => {
    return `${process.env.REACT_APP_FASFASREFERURL}/signup/?afid=${affiliateCode}`;
  };

  const location = useLocation();
  const locationState = location.state || {};
  useEffect(() => {
    dispatch(getAffiliateEarnsData(locationState?.affiliateCode));

  }, [locationState?.affiliateCode])
  return (
    <React.Fragment>
      <div className="SB-page-content">
        <div className="SB-myAccountSection-container SB-loyalty SB-allearnings">
          <div className="SB-pageHeader">
            <div className="SB-pageBackButton">
              <div className="SB-iconSVG" onClick={() => navigate(-1)}>
                <svg xmlns="http://www.w3.org/2000/svg">
                  <use xlinkHref={`${icons}#${"icon-back"}`}></use>
                </svg>
              </div>
            </div>
            <div className="SB-pageHeader-title">All Earnings</div>
          </div>
          <div className="SB-content">
            <div className="SB-myAccount-sectionBox SB-loyalty-affiliate">
              <div className="SB-myAccount-sectionBox_content">
                {/* <div className="SB-loyalty-affiliateName">
                  {selectedUserName ? (
                    <div className="SB-loyalty-affiliate-registeredName">
                      <p>
                        Your VIP Name: <b>{selectedUserName}</b>
                      </p>
                    </div>
                  ) : (
                    <div className="SB-form-group">
                      <div className="SB-form-label">
                        <span>Enter Your Name</span>
                      </div>
                      <div className="SB-form-control SB-error">
                        <input
                          type="text"
                          value={selectedUserName ? selectedUserName : userName}
                          placeholder="Enter Your Name Here"
                          onChange={(e) => handleNameInput(e)}
                          disabled={selectedUserName}
                        />
                      </div>
                      <div className="SB-form-errorMsg">
                        <span>{userNameErrMsg}</span>
                      </div>
                    </div>
                  )}
                </div> */}
                <div className="SB-loyalty-affiliateSite">
                  <div className="SB-affiliateSite-title">Your Referral Site</div>
                  <div className="SB-affiliateSite-details">
                    <div className="SB-affiliateSite-link">
                      <div className="SB-iconSVG">
                        <svg xmlns="http://www.w3.org/2000/svg">
                          <use xlinkHref={`${icons}#${"icon-link"}`} />
                        </svg>
                        <span onClick={linkmode}>FasFasgames{userName && `/${userName}`}</span>
                      </div>
                    </div>
                    {selectedUserName && (
                      <div className="SB-affiliate-icons">
                        <div className="SB-iconSVG">
                          <svg xmlns="http://www.w3.org/2000/svg">
                            <use xlinkHref={`${icons}#${"icon-share"}`} />
                          </svg>
                        </div>
                        <div className="SB-affiliate-copy">
                          <div className="SB-iconSVG" onClick={shareUrl}>
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use xlinkHref={`${icons}#${"icon-copy"}`} />
                            </svg>
                          </div>
                          <span>{copiedText}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="SB-affiliate-discription">
                  <p>
                    Earn a cashback via your referrals.{" "}
                    <Link to={"/terms-conditions"} style={{ color: "var(--color-highlight)" }}>
                      <b>T&C</b>
                    </Link>{" "}
                    Apply.
                  </p>
                </div>
                <div className="SB-signupUsers">
                  <div className="SB-usersCount">
                    <div className="SB-countBox">
                      <div className="SB-countBox-header">No. of Players</div>
                      <div className="SB-countBox-value">
                        {affiliatesData?.totalSignups
                          ? affiliatesData?.totalSignups
                          : 0}
                      </div>
                    </div>
                    <div className="SB-countBox">
                      <div className="SB-countBox-header">
                        Lifetime cashback earned
                      </div>
                      <div className="SB-countBox-value">
                        {affiliatesData?.totalEarnings
                          ? (affiliatesData?.totalEarnings).toFixed(2)
                          : 0}
                      </div>
                    </div>
                    <div className="SB-countBox">
                      <div className="SB-countBox-header">
                        Available cashback
                      </div>
                      <div className="SB-countBox-value">
                        {/* {vipreportData?.data?.length > 0 &&
                          vipreportData?.data[0].totalGgr > 0
                          ? (
                            (vipreportData.data[0].totalGgr *
                              endpoints.commissionPercentage) /
                            100
                          ).toFixed(2)
                          : 0} */}
                        {affiliatesData?.availableEarnings ?
                          (affiliatesData?.availableEarnings).toFixed(2) : 0}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="SB-myAccount-sectionBox SB-loyalty-benefits">
              <div className="SB-myAccount-sectionBox_header">
                <span>All Earnings</span>
                <div className="SB-select SB-selectAuto SB-earningDropdown">
                  <select style={{ width: "137px" }} onChange={(e) => handleDataRange(e)}>
                    <option value="last30">Last 30 Days</option>
                    <option value="last7">Last 7 Days</option>
                    <option value="custom">Custom</option>
                  </select>
                </div>
              </div>
              {dateRange === "custom" &&
                (<div className="SB-row SB-customEarnings" >
                  <div className="SB-col">
                    <div className="SB-form-group">
                      <div className="SB-form-label">From Date</div>
                      <div className="SB-form-control">
                        <input
                          id="accountEmail"
                          type="date"
                          placeholder="Enter Limit"
                          value={startDate.split('T')[0]}
                          onChange={(e) => {
                            const selectedDate = new Date(e.target.value);
                            selectedDate.setUTCHours(0, 0, 0, 0);
                            const isoString = selectedDate.toISOString();
                            setStartDate(isoString);
                          }}

                        />
                      </div>
                    </div>
                  </div>
                  <div className="SB-col">
                    <div className="SB-form-group">
                      <div className="SB-form-label">To Date</div>
                      <div className="SB-form-control">
                        <input
                          id="accountEmail"
                          type="date"
                          placeholder="Enter Limit"
                          value={endDate.split('T')[0]}
                          onChange={(e) => {
                            const selectedDate = new Date(e.target.value);
                            selectedDate.setUTCHours(23, 59, 59, 999);
                            const isoString = selectedDate.toISOString();
                            setEndDate(isoString);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>)
              }
              <div className="SB-userLevel-table SB-allearnings-table SB-table-scrollable">
                <table>
                  <colgroup>
                    <col />
                    <col />
                    <col />
                    <col />
                    <col />
                    <col className="active" />
                  </colgroup>
                  <thead>
                    <tr>
                      <td>Mobile Number</td>
                      <td>Registered on</td>
                      <td>Games PLayed</td>
                      <td>Earnings</td>
                    </tr>
                  </thead>
                  <tbody>
                    {!allEarnLoader &&
                      affiliateDetailsData?.data?.length > 0 &&
                      affiliateDetailsData?.data?.map((details, ind) => (
                        <tr>
                          <td>{details?.name}</td>
                          <td>{details?.registeredDate.split('T')[0]}</td>
                          <td>{details?.gamesPlayed}</td>
                          <td>{details?.earnings ? (details?.earnings).toFixed(2) : 0}</td>
                        </tr>
                      ))


                    }

                  </tbody>
                </table>
              </div>
              {
                allEarnLoader ?
                  <div className='SB-section-loader'>
                    <div className='SB-section-loader-container'>
                      <span className='SB-dot'></span>
                      <span className='SB-dot'></span>
                      <span className='SB-dot'></span>
                      <span className='SB-dot'></span>
                    </div>
                  </div>
                  : ""
              }
              {!allEarnLoader &&
                (affiliateDetailsData?.data?.length === 0 || affiliateDetailsData?.data === undefined) &&
                <div className="SB-msgBox">
                  <div className="SB-msgBox-container">
                    Currently there is no data available
                  </div>
                </div>
              }
              {!allEarnLoader && <PaginationComponent
                currentPage={currentPage}
                totalCount={affiliateDetailsData?.totalRecords || 0}
                pageSize={PageSize}
                onPageChange={page => setCurrentPage(page)}
                setCurrentPage={setCurrentPage}
              />}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ViewAllEarns;
